export async function tryRefreshToken(): Promise<boolean> {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  try {
    const res = await fetch(`${apiUrl}/login/refresh-token`, {
      method: 'POST',
      credentials: 'include',
    });

    if (res.ok) {
      const data = await res.json();
      if (data.access_token) {
        localStorage.setItem('access_token', data.access_token);
        return true;
      }
    }
  } catch (e) {
    console.error('Erro ao tentar renovar token', e);
  }

  localStorage.removeItem('access_token');
  return false;
}

export async function fetchAuth(input: RequestInfo, init?: RequestInit) {
  const token = localStorage.getItem('access_token');
  const headers = new Headers(init?.headers || {});

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const config: RequestInit = {
    ...init,
    headers,
    credentials: 'include',
  };

  let response = await fetch(input, config);

  if (response.status === 401) {
    const refreshed = await tryRefreshToken();

    if (refreshed) {
      const newToken = localStorage.getItem('access_token');
      if (newToken) {
        headers.set('Authorization', `Bearer ${newToken}`);
        config.headers = headers;
        response = await fetch(input, config);
      }
    }
  }

  return response;
}
